export default {
    _prefix: "BottomBanner",
    FormButtons: {
        Save: "Save",
        Publish: "Publish Form",
        Disable: "Disable Form",
        CopyForm: "Copy Form",
        DiscardChanges: "Discard Changes",
    },
    disable: {
        disable: "Disable",
        cancel: "Cancel",
        confirm: {
            error: {
                nameMismatch:
                    "The provided name and the form name do not match",
            },
            input: {
                placeholder: (data: { formName: string }) =>
                    "Enter {{{formName}}}",
            },
            title: "To confirm, please enter {{#Strong}}{{/Strong}} below",
            warning: {
                expire: "Survey links already sent to customers for this form will use the latest {{#Strong}}published{{/Strong}} and {{#Strong}}enabled{{/Strong}} version. While there is no such form, the survey links will appear expired to the customers. Once disabled, surveys for customers that have already begun taking this version of the survey form will also appear to be expired.",
                fallback:
                    "Survey links using this form will fall back to the most recently {{#Strong}}published{{/Strong}} and {{#Strong}}enabled{{/Strong}} version of the form if the survey respondent has not begun taking the survey.",
                title: "The following conditions apply to disabling a form",
            },
        },
    },
    aiScoringFailure: {
        title: "AI Scoring failed to save",
        content:
            "The evaluation form was saved, but changes made to AI Scoring configurations failed to save.",
        retry: "Retry Save",
        discard: "Discard Changes",
    },
    ManageTemplateButton: "Manage Question Templates",
    formNameAfterCopy: (data: { formName: string }) => "Copy of {{{formName}}}",
};
